import {
    Checkbox as RawCheckbox,
    FormGroup,
    FormControlLabel,
    styled,
} from '@mui/material'

const Checkbox = ({
    label,
    disabled,
    defaultChecked,
    checkboxColor = 'secondary',
    checkboxProps,
    ...p
}) => {
    if (label) {
        return (
            <FormGroup {...p}>
                <FormControlLabel
                    style={{marginRight: 0}}
                    control={
                        <StyledChecbox
                            defaultChecked={defaultChecked}
                            color={checkboxColor}
                            {...checkboxProps}
                        />
                    }
                    label={label}
                    disabled={disabled}
                />
            </FormGroup>
        )
    }

    return <RawCheckbox {...p} defaultChecked />
}
export default Checkbox

const StyledChecbox = styled(RawCheckbox)`
    padding: 0;
    padding-inline-end: 10px;
`
